import { chatApi as defaultChatApi } from "@b2bportal/chat-api";
import { emailApi as defaultEmailApi } from "@b2bportal/email-api";
import { ivrApi as defaultIvrApi } from "@b2bportal/ivr-api";
import axios from "axios";

export const selfServeApi = {
  ...defaultChatApi(axios),
  ...defaultEmailApi(axios),
  ...defaultIvrApi(axios),
};
